type SkillTaxonomyTreeButtonsType = {
  onExpandTree: (isExpand: boolean) => void;
};

export const SkillTaxonomyTreeButtons = ({ onExpandTree }: SkillTaxonomyTreeButtonsType) => (
  <>
    {[true, false].map((expand) => (
      <button
        key={expand ? 'expand' : 'collapse'}
        type="button"
        onClick={() => onExpandTree(expand)}
        className="btn btn-sm btn-tool-box margin-left"
        style={{
          padding: '0px 5px',
          lineHeight: '1.5em',
          height: 'auto',
        }}
      >
        <i className={`fa fa-caret-${expand ? 'down' : 'right'}`} /> {translate(expand ? 'Expand all' : 'Collapse all')}
      </button>
    ))}
  </>
);
